export const LOAD_CONTENT = 'hg/account/LOAD_CONTENT';

export const account = (state = {}, action = {}) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const loadContent = () => ({ type: LOAD_CONTENT });

export default account;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Account/account/account.js
 **/